import React, { useRef } from "react";

import { useTranslation } from "react-i18next";

import TableTemplate from "@components/Table/TableTemplate";
import { BOOKS_USER_ENDPOINT } from "@constants/Endpoints";
import { getReportTypeName } from "@constants/ReportTypes";
import { bookNumberMask, isDateBetweenDates, parsePriceCurrency } from "@helpers/utils/utils";

import HeaderStudent from "./HeaderStudent/HeaderStudent";
import { NotificationModal } from "./NotificationModal/NotificationModal";
import { StatusCell } from "./StatusCell/StatusCell";
import "./StudentHomePage.scss";

function StudentHomePageView({
    dates,
    barcode,
    books,
    loading,
    showNotificationModal,
    onStudentHeaderUpdate,
    onStudentHeaderComplete,
    onNotifModalHide,
    onStatusCellUpdateBook,
}) {
    const [t] = useTranslation();
    const tableTemplateRef = useRef(null);

    const columns = [
        {
            name: "book.title",
            headerCaption: t("Title"),
            size: "big",
            canSort: false,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "state",
            headerCaption: t("Status"),
            caption: (x) => (
                <StatusCell
                    book={x}
                    blockedBooks={
                        !isDateBetweenDates(new Date(), new Date(dates.start), new Date(dates.end)) ||
                        barcode.isCompleted
                    }
                    updateBook={onStatusCellUpdateBook}
                />
            ),
            canSort: false,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "reason",
            headerCaption: t("Reason"),
            size: "large",
            caption: (x) => (
                <div className="reason">
                    {x.state === 0 && "-"}
                    {x.state === 1 && "-"}
                    {x.state === 2 && t(getReportTypeName(x.reportType))}
                    {x.state === 3 && t("KeepedSummertask")}
                </div>
            ),
            canSort: false,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "book.isbn",
            headerCaption: t("ISBN"),
            canSort: false,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "book.bookNumber",
            headerCaption: t("BookNumber"),
            size: "normal-x",
            textAlign: "right",
            caption: (x) => bookNumberMask(x.book.bookNumber),
            canSort: false,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "price",
            headerCaption: t("FineAmount"),
            caption: (x) => (
                <div className={"price"}>{x.state === 2 && x.isInvoiceAplied ? parsePriceCurrency(x.price) : "-"}</div>
            ),
            textAlign: "right",
            canSort: false,
            canFilter: false,
            canEdit: false,
        },
    ];

    return (
        <div className="student-home-page">
            <div className="content trans-fromTop">
                <HeaderStudent
                    dates={dates}
                    barcode={barcode}
                    books={books}
                    handleUpdate={onStudentHeaderUpdate}
                    handleComplete={onStudentHeaderComplete}
                />
                {loading ? (
                    <div className="loader-container">
                        <div className="loader" />
                    </div>
                ) : (
                    <TableTemplate
                        ref={tableTemplateRef}
                        // @ts-ignore
                        title={""}
                        dataSource={{
                            count: books.length,
                            list: books,
                        }}
                        endpoint={BOOKS_USER_ENDPOINT}
                        columns={columns}
                        uniqueId="isbn"
                        pageSize={100}
                        paginator={false}
                    />
                )}
                {showNotificationModal && <NotificationModal show={showNotificationModal} onHide={onNotifModalHide} />}
            </div>
        </div>
    );
}

export default StudentHomePageView;
